/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WeaknessDefinitionTenantEntity
 */
export interface WeaknessDefinitionTenantEntity {
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    tenantId?: string;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionTenantEntity
     */
    discoveredAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionTenantEntity
     */
    lastSeenAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionTenantEntity
     */
    decommissionedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    sourceSystem?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    sourceRecordId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    status?: WeaknessDefinitionTenantEntityStatusEnum;
    /**
     * 
     * @type {number}
     * @memberof WeaknessDefinitionTenantEntity
     */
    version?: number;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof WeaknessDefinitionTenantEntity
     */
    extendedAttributes?: { [key: string]: any; };
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionTenantEntity
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof WeaknessDefinitionTenantEntity
     */
    updatedAt?: Date;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    createdBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    updatedBy?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    identifier?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    weaknessType?: WeaknessDefinitionTenantEntityWeaknessTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    framework?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    frameworkId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    severity?: WeaknessDefinitionTenantEntitySeverityEnum;
    /**
     * 
     * @type {number}
     * @memberof WeaknessDefinitionTenantEntity
     */
    riskScore?: number;
    /**
     * 
     * @type {number}
     * @memberof WeaknessDefinitionTenantEntity
     */
    cvssScore?: number;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    cvssVector?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    category?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    controlId?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    remediation?: string;
    /**
     * 
     * @type {string}
     * @memberof WeaknessDefinitionTenantEntity
     */
    workaround?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessDefinitionTenantEntity
     */
    references?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof WeaknessDefinitionTenantEntity
     */
    affectedProducts?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessDefinitionTenantEntity
     */
    exploitAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessDefinitionTenantEntity
     */
    patchAvailable?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessDefinitionTenantEntity
     */
    active?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof WeaknessDefinitionTenantEntity
     */
    decommissioned?: boolean;
}


/**
 * @export
 */
export const WeaknessDefinitionTenantEntityStatusEnum = {
    Active: 'ACTIVE',
    Inactive: 'INACTIVE',
    Decommissioned: 'DECOMMISSIONED',
    Deleted: 'DELETED'
} as const;
export type WeaknessDefinitionTenantEntityStatusEnum = typeof WeaknessDefinitionTenantEntityStatusEnum[keyof typeof WeaknessDefinitionTenantEntityStatusEnum];

/**
 * @export
 */
export const WeaknessDefinitionTenantEntityWeaknessTypeEnum = {
    Vulnerability: 'VULNERABILITY',
    ConfigurationFinding: 'CONFIGURATION_FINDING',
    ComplianceGap: 'COMPLIANCE_GAP',
    PolicyGap: 'POLICY_GAP',
    InsuranceGap: 'INSURANCE_GAP',
    ProcedureGap: 'PROCEDURE_GAP',
    RedTeamFinding: 'RED_TEAM_FINDING',
    SecurityAssessment: 'SECURITY_ASSESSMENT',
    PenetrationTest: 'PENETRATION_TEST',
    NetworkMisconfiguration: 'NETWORK_MISCONFIGURATION',
    AccessControlIssue: 'ACCESS_CONTROL_ISSUE',
    IdentityMisconfiguration: 'IDENTITY_MISCONFIGURATION',
    ApplicationSecurity: 'APPLICATION_SECURITY',
    ApiSecurity: 'API_SECURITY',
    CspmFinding: 'CSPM_FINDING',
    CloudMisconfiguration: 'CLOUD_MISCONFIGURATION',
    Custom: 'CUSTOM',
    Other: 'OTHER'
} as const;
export type WeaknessDefinitionTenantEntityWeaknessTypeEnum = typeof WeaknessDefinitionTenantEntityWeaknessTypeEnum[keyof typeof WeaknessDefinitionTenantEntityWeaknessTypeEnum];

/**
 * @export
 */
export const WeaknessDefinitionTenantEntitySeverityEnum = {
    Critical: 'CRITICAL',
    High: 'HIGH',
    Medium: 'MEDIUM',
    Low: 'LOW',
    Info: 'INFO'
} as const;
export type WeaknessDefinitionTenantEntitySeverityEnum = typeof WeaknessDefinitionTenantEntitySeverityEnum[keyof typeof WeaknessDefinitionTenantEntitySeverityEnum];


/**
 * Check if a given object implements the WeaknessDefinitionTenantEntity interface.
 */
export function instanceOfWeaknessDefinitionTenantEntity(value: object): value is WeaknessDefinitionTenantEntity {
    return true;
}

export function WeaknessDefinitionTenantEntityFromJSON(json: any): WeaknessDefinitionTenantEntity {
    return WeaknessDefinitionTenantEntityFromJSONTyped(json, false);
}

export function WeaknessDefinitionTenantEntityFromJSONTyped(json: any, ignoreDiscriminator: boolean): WeaknessDefinitionTenantEntity {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'discoveredAt': json['discoveredAt'] == null ? undefined : (new Date(json['discoveredAt'])),
        'lastSeenAt': json['lastSeenAt'] == null ? undefined : (new Date(json['lastSeenAt'])),
        'decommissionedAt': json['decommissionedAt'] == null ? undefined : (new Date(json['decommissionedAt'])),
        'sourceSystem': json['sourceSystem'] == null ? undefined : json['sourceSystem'],
        'sourceRecordId': json['sourceRecordId'] == null ? undefined : json['sourceRecordId'],
        'status': json['status'] == null ? undefined : json['status'],
        'version': json['version'] == null ? undefined : json['version'],
        'extendedAttributes': json['extendedAttributes'] == null ? undefined : json['extendedAttributes'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'updatedAt': json['updatedAt'] == null ? undefined : (new Date(json['updatedAt'])),
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'updatedBy': json['updatedBy'] == null ? undefined : json['updatedBy'],
        'identifier': json['identifier'] == null ? undefined : json['identifier'],
        'weaknessType': json['weaknessType'] == null ? undefined : json['weaknessType'],
        'framework': json['framework'] == null ? undefined : json['framework'],
        'frameworkId': json['frameworkId'] == null ? undefined : json['frameworkId'],
        'title': json['title'] == null ? undefined : json['title'],
        'description': json['description'] == null ? undefined : json['description'],
        'severity': json['severity'] == null ? undefined : json['severity'],
        'riskScore': json['riskScore'] == null ? undefined : json['riskScore'],
        'cvssScore': json['cvssScore'] == null ? undefined : json['cvssScore'],
        'cvssVector': json['cvssVector'] == null ? undefined : json['cvssVector'],
        'category': json['category'] == null ? undefined : json['category'],
        'controlId': json['controlId'] == null ? undefined : json['controlId'],
        'remediation': json['remediation'] == null ? undefined : json['remediation'],
        'workaround': json['workaround'] == null ? undefined : json['workaround'],
        'references': json['references'] == null ? undefined : json['references'],
        'affectedProducts': json['affectedProducts'] == null ? undefined : json['affectedProducts'],
        'exploitAvailable': json['exploitAvailable'] == null ? undefined : json['exploitAvailable'],
        'patchAvailable': json['patchAvailable'] == null ? undefined : json['patchAvailable'],
        'active': json['active'] == null ? undefined : json['active'],
        'decommissioned': json['decommissioned'] == null ? undefined : json['decommissioned'],
    };
}

export function WeaknessDefinitionTenantEntityToJSON(json: any): WeaknessDefinitionTenantEntity {
    return WeaknessDefinitionTenantEntityToJSONTyped(json, false);
}

export function WeaknessDefinitionTenantEntityToJSONTyped(value?: WeaknessDefinitionTenantEntity | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'tenantId': value['tenantId'],
        'discoveredAt': value['discoveredAt'] == null ? undefined : ((value['discoveredAt']).toISOString()),
        'lastSeenAt': value['lastSeenAt'] == null ? undefined : ((value['lastSeenAt']).toISOString()),
        'decommissionedAt': value['decommissionedAt'] == null ? undefined : ((value['decommissionedAt']).toISOString()),
        'sourceSystem': value['sourceSystem'],
        'sourceRecordId': value['sourceRecordId'],
        'status': value['status'],
        'version': value['version'],
        'extendedAttributes': value['extendedAttributes'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'updatedAt': value['updatedAt'] == null ? undefined : ((value['updatedAt']).toISOString()),
        'createdBy': value['createdBy'],
        'updatedBy': value['updatedBy'],
        'identifier': value['identifier'],
        'weaknessType': value['weaknessType'],
        'framework': value['framework'],
        'frameworkId': value['frameworkId'],
        'title': value['title'],
        'description': value['description'],
        'severity': value['severity'],
        'riskScore': value['riskScore'],
        'cvssScore': value['cvssScore'],
        'cvssVector': value['cvssVector'],
        'category': value['category'],
        'controlId': value['controlId'],
        'remediation': value['remediation'],
        'workaround': value['workaround'],
        'references': value['references'],
        'affectedProducts': value['affectedProducts'],
        'exploitAvailable': value['exploitAvailable'],
        'patchAvailable': value['patchAvailable'],
        'active': value['active'],
        'decommissioned': value['decommissioned'],
    };
}

